module.exports = __webpack_public_path__ + "media/img/auth-side-cover-brand-front-01-37b83ded244f482f52b6725a44a08c40.svg";